import { registerValidator } from "./form/useForm"

export function registerValidators() {
    registerValidator("PairedRanges", "steps", (typeCtx, fd, value, typeValidator) => {

            const result = typeValidator(typeCtx, fd, value)
            if (!result[1])
            {
                const [value ] = result

                if (value < 2 || (value & 1) === 1)
                {
                    return [null, "Value must be an even positive number"]
                }
            }
            return result
        }
    )
}
